var OfferContextAttribute = /*@__PURE__*/ (function () {
    function OfferContextAttribute(data) {
        if (data.type) {
            this.type = data.type;
        }
        if (data.value) {
            this.value = data.value;
        }
    }
    return OfferContextAttribute;
}());
export { OfferContextAttribute };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/offer/offer.context-attribute.ts
// module id = null
// module chunks = 